<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                            </span></h2>
                </v-row>
        
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >
                    <v-row>
                      <v-col cols="8" sm="8" class="pb-n4">
                       <v-text-field
                                outlined
                                :label="this.$t('performancemanagement.goal')"
                                type="text"
                                ref="goal"
                                :rules="[rules.required]"
                                v-model="formData.goal"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('performancemanagement.kpi')"
                                type="text"
                                ref="kpi"
                                :rules="[rules.required]"
                                v-model="formData.kpi"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('performancemanagement.targetoption')"
                                type="text"
                                ref="pmtargetoptionid"
                                v-model="formData.pmtargetoptionid"
                                dense
                                :items="targetOptionList"
                                @change="changeTargetOption(formData.pmtargetoptionid)"
                                @input="updateValue"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="3" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmassementrecord.pmassessmentcalculationmethod')"
                                type="text"
                                ref="pmcalmethodid"
                                v-model="formData.pmcalmethodid"
                                dense
                                @input="updateValue"
                                :items="calculationMethodList"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="mx-0">
                            <v-row>
                                <v-col v-if="formData.targetType == 'Target, threshold, stretch'" cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.threshold')"
                                        type="number"
                                        v-model="formData.threshold"
                                        ref="threshold"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('columns.target')"
                                        type="number"
                                        v-model="formData.target"
                                        ref="target"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="formData.targetType == 'Target, threshold, stretch'" cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmreviewexercisesectioncard.stretch')"
                                        type="number"
                                        v-model="formData.stretch"
                                        ref="stretch"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('pmkpiset.subperiodcount')"
                                        type="number"
                                        v-model="formData.subperiodcount"
                                        ref="subperiodcount"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('performancemanagement.weightage')"
                                        type="number"
                                        v-model="formData.weightage"
                                        ref="weightage"
                                        dense
                                        class="v-input"
                                        @input="updateValue"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="8" class="pb-n4 mt-n8">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmkpiitem.kpifinalscorecalmethod')"
                                        type="text"
                                        ref="pmkpifinalscorecalmethodid"
                                        v-model="formData.pmkpifinalscorecalmethodid"
                                        dense
                                        :rules="[rules.required]"
                                        :items="KPIFinalScoreList"
                                        @input="updateValue"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="7" sm="7" class="pb-n4 mt-n8">
                                    <v-autocomplete
                                        outlined
                                        :label="$t('pmkpiitem.kpicategory')"
                                        type="text"
                                        ref="pmkpicatid"
                                        :rules="[rules.required]"
                                        v-model="formData.pmkpicatid"
                                        dense
                                        :items="KPICategoryList"
                                        @input="updateValue"
                                        @change="changeKPICategoryHandler(formData.pmkpicatid)"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('columns.code')"
                                        type="text"
                                        v-model="formData.pmkpicatcode"
                                        readonly
                                        dense
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                    <v-dialog v-model="KPICategoryDialog" max-width="500px" persistent>
                                        <template v-slot:activator="{ on }">
                                            <v-btn dense v-on="on">
                                                <v-icon>edit</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-card>
                                            <app-genericform 
                                                v-bind:parentData = "{
                                                    tabItems: KPICategoryItems,
                                                    formTitle: $t('pmkpiitem.kpicategory'),
                                                    formId: 'kpicat'
                                                }"
                                                v-on:input="itemData = $event"
                                                v-on:saveKPICategory="saveKPICategoryHandler"
                                                v-on:deleteKPICategory="deleteKPICategoryHandler($event)"
                                            />

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="warning"
                                                    text
                                                    @click="KPICategoryDialog = false"
                                                >
                                                {{$t('button.close')}}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="7" sm="7" class="pb-n4 mt-n8">
                                    <v-autocomplete
                                        outlined
                                        clearable
                                        :label="$t('Setupratingset.ratingset')"
                                        type="text"
                                        ref="pmratesetid"
                                        v-model="formData.pmratesetid"
                                        dense
                                        :items="ratingSetList"
                                        @input="updateValue"
                                        @change="updateRatingSetCode(formData.pmratesetid)"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                                    <v-text-field
                                        outlined
                                        :label="$t('Setupratingset.ratingsetdesc')"
                                        type="text"
                                        v-model="formData.pmratesetdesc"
                                        readonly
                                        dense
                                        background-color="#ffeab2"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="pb-n4 mt-n8">
                                    <v-checkbox
                                        v-model="formData.basedonpercentage"
                                        :label="$t('pmkpiitem.basedonpercentage')"
                                        ref="basedonpercentage"
                                        dense
                                        @change="updateValue"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>

                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit
                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" 
                />

            </v-form>
        </v-container>
    </div>
</template>

<script>
import GenericForm from '../../generic/GridForm';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-genericform': GenericForm
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                pmkpitypeid: this.parentObject.data.pmkpitypeid, 
                description: this.parentObject.data.description,
                goal: this.parentObject.data.goal,
                kpi: this.parentObject.data.kpi,
                pmtargetoptionid: this.parentObject.data.pmtargetoptionid,
                pmcalmethodid: this.parentObject.data.pmcalmethodid,
                targetType: this.parentObject.data.targetType,
                threshold: this.parentObject.data.threshold,
                target: this.parentObject.data.target,
                stretch: this.parentObject.data.stretch,
                subperiodcount: this.parentObject.data.subperiodcount,
                weightage: this.parentObject.data.weightage,
                pmkpifinalscorecalmethodid: this.parentObject.data.pmkpifinalscorecalmethodid,
                pmkpicatid: this.parentObject.data.pmkpicatid,
                pmkpicatcode: this.parentObject.data.pmkpicatcode,
                pmratesetid: this.parentObject.data.pmratesetid,
                pmratesetdesc: this.parentObject.data.pmratesetdesc,
                basedonpercentage: this.parentObject.data.basedonpercentage,
                stamp: this.parentObject.data.stamp,
                userid: this.$store.getters.userId,
            },

            targetOptionFull: [],
            targetOptionList: [],
            calculationMethodList: [],
            KPIFinalScoreList: [],

            KPICategoryDialog: false,
            kpicategories: [],
            KPICategoryList: [],
            KPICategoryItems: [],

            ratingSet: [],
            ratingSetList: [],

            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.isEdit,
            search: this.parentObject.searchnew,

        }
    },

    methods: {
        updateRatingSetCode(value) {
            const selectedRatingSet = this.ratingSetList.find(item => item.value === value);
            if (selectedRatingSet) {
                this.formData.pmratesetdesc = selectedRatingSet.text;
            } else {
                this.formData.pmratesetdesc = ''; // Clear the text if no match is found
            }
        },

        getKPICategoryListHandler() {
            let vm = this;

            this.$store.dispatch('get', {url: '/kpicat/all'})
                .then(res => {
                    vm.kpicategories = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.KPICategoryList.push(
                            {
                                text: res.data.rec[i].name,
                                value: res.data.rec[i].id
                            }
                        )

                        vm.KPICategoryItems.push(
                            {
                                id: res.data.rec[i].id,
                                code: res.data.rec[i].code,
                                desc: res.data.rec[i].name,
                                stamp: res.data.rec[i].stamp
                            }
                        )
                    }
                    
                    if (vm.formData.pmkpicatid) {
                        vm.changeKPICategoryHandler(vm.formData.pmkpicatid);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        changeKPICategoryHandler(id) {
            let item = this.kpicategories.find(item => item.id == id);

            this.formData.pmkpicatcode = item.code;
        },

        saveKPICategoryHandler() {
            let vm = this;
            if (this.itemData.itemid) {
                this.$store.dispatch('put', {url: '/kpicat/' + this.itemData.itemid, payload: {
                    code: vm.itemData.itemcode,
                    name: vm.itemData.itemdesc,
                    stamp: vm.itemData.itemstamp
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // reset all arrays
                        vm.kpicategories = [];
                        vm.KPICategoryList = [],
                        vm.KPICategoryItems = [],

                        this.getKPICategoryListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {url: '/kpicat/create', payload: {
                    code: vm.itemData.itemcode,
                    name: vm.itemData.itemdesc,
                    userid: this.$store.getters.userId,
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // reset all arrays
                        vm.kpicategories = [];
                        vm.KPICategoryList = [],
                        vm.KPICategoryItems = [];

                        this.getKPICategoryListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteKPICategoryHandler($event) {
            let vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {url: '/kpicat/' + $event.id + '/' + this.$store.getters.userId})
                .then(res => {
                    if (res.data.status == 200) {
                        // reset all arrays
                        vm.kpicategories = [];
                        vm.KPICategoryList = [],
                        vm.KPICategoryItems = [],

                        this.getKPICategoryListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        addItemHandler($event) {
            this.formData.ratingscalesetdetail=$event
    
            this.updateValue();
        },


        updateValue() {
            this.$emit('input', {
                pmkpitypeid: this.formData.pmkpitypeid,
                description: this.formData.description,
                goal: this.formData.goal,
                kpi: this.formData.kpi,
                pmtargetoptionid: this.formData.pmtargetoptionid,
                targetType: this.formData.targetType,
                pmcalmethodid: this.formData.pmcalmethodid,
                threshold: this.formData.threshold,
                target: this.formData.target,
                stretch: this.formData.stretch,
                subperiodcount: this.formData.subperiodcount,
                weightage: this.formData.weightage,
                pmkpifinalscorecalmethodid: this.formData.pmkpifinalscorecalmethodid,
                pmkpicatid: this.formData.pmkpicatid,
                pmkpicatcode: this.formData.pmkpicatcode,
                pmratesetid: this.formData.pmratesetid,
                pmratesetdesc: this.formData.pmratesetdesc,
                basedonpercentage: this.formData.basedonpercentage,
                stamp: this.formData.stamp,
                userid: this.formData.userid,
            });
        },

        loadTargetOptionListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpitargetoption/all' })
            .then((res) => {

                vm.targetOptionFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.targetOptionList.push({
                        text: res.data.rec[i].targetoption,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeTargetOption(id) {
            let item = this.targetOptionFull.find((item) => item.id === id);
            this.formData.targetType = item.targetoption;
        },

        loadCalculationMethodListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpicalculationmethod/all' })
            .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.calculationMethodList.push({
                        text: res.data.rec[i].calmethod,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        loadKPIFinalScoreListHandler() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpifinalscorecalmethod/all' })
            .then((res) => {
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.KPIFinalScoreList.push({
                        text: res.data.rec[i].description,
                        value: res.data.rec[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        loadRatingSet() {
            const vm = this;
            this.$store.dispatch('get', { url: "/ratingset/active/all" })
                .then(function (res) {
                    vm.ratingSet = res.data.rec;

                    for (let i = 0; i < vm.ratingSet.length; i++) {
                        vm.ratingSetList.push({
                            text: vm.ratingSet[i].rateset,
                            value: vm.ratingSet[i].id,
                        });
                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
        },

        changeKPITypeHandler(id) {
            if (id === 1) {
                this.formData.description = null;
            } 

            this.updateValue();
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'kpiitemlist', params: { search: this.search}});
        },
    },

    mounted() {
        this.loadTargetOptionListHandler();
        this.loadCalculationMethodListHandler();
        this.loadKPIFinalScoreListHandler();
        this.getKPICategoryListHandler();
        this.loadRatingSet();
    }
    
}
</script>